/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class PromptsAPI
 * @hideconstructor
 * @classdesc API class to handle prompt fault.
 */
define([], () => {

	class PromptsAPI {

		/**
		 * @function PromptsAPI#isPromptFault
		 * @description Check whether a failed response is prompt fault.
		 * @public
		 * @param {object} errorResponse The failed query response.
		 * 
		 * @return true if the response status is prompt fault.
		 */
		isPromptFault() {}

		/**
		 * @function PromptsAPI#getPromptSpecList
		 * @description get prompt spec list from prompt fault.
		 * @public
		 * 
		 * @param {object} errorResponse The failed query response.
		 * @return {object[]} An array of prompt spec.
		 */
		getPromptSpecList() {}

		/**
		 * @function PromptsAPI#openPromptView
		 * @description Open prompt dialog and rerun original query with picked values from the dialog.
		 * @public
		 * @async
		 * 
		 * @param {object[]} specList An array of prompt spec.
		 * @param {VisualizationAPI} [visualization] The {@link VisualizationAPI} object
		 * @param {Boolean} [isPreview=false] true if this is a preview visualization (and will not prompt)
		 * @return {Promise<Object[]>} Returns a promise that will be resolved to an array of {@link PromptValueSpec} object
		 */
		openPromptView() {}
	}

	return PromptsAPI;
});